import { Component } from '@angular/core';

@Component({
  selector: 'icon-google-plus',
  templateUrl: './icon-google-plus.component.html',
  styles: []
})
export class IconGooglePlusComponent {}
